import React, {useState} from 'react';

import styled from 'styled-components';
import theme from '../../../../styles/theme';

import moment from 'moment';

import { useEffect } from 'react';

import CommonDataGrid from '../../../common/CommonDataGrid';

import { useGetInoutHistStatic } from '../../../../interface/inout';
import { TextField } from '@mui/material';
import { Row } from '../../../../styles/common';
import Button from '../../../common/Button';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    div {
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const histColumns = [
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'iot_tpnm', headerName: '반출입분류', width:120 },
    { field: 'iot_nm', headerName: '과업명', width:250 },
    { field: 'reg_nm', headerName: '담당자', width:120 },
    { field: 'reg_dt', headerName: '등록일', width:150 },
    { field: 'io_stnm', headerName: '반출입구분', width:120 },
    { field: 'ret_stnnm', headerName: '반입상태', width:120 },
    { field: 'is_ing', headerName: '반출입작업상태', width:120 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'cat_nm', headerName: '분류', width:150 },
    { field: 'model_nm', headerName: '모델명', width:120 },
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'item_stnm', headerName: '자산상태', width:120 },
    { field: 'r_item', headerName: '연계자산', width:200 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'contents', headerName: '내용', width:200 },
    { field: 'descr', headerName: '비고', width:200 },
]

const InoutHist = () => {

    const [histList, setHistList] = useState([]);
    const [sendParam,setSendParam] = useState({});

    const {data : itemHist, isLoading, refetch} = useGetInoutHistStatic(sendParam);

    const handleValueChange = (id, val) => {
        const temp = sendParam;
        temp[id]=val;
        setSendParam(temp);
    }

    const goSearch = () => {
        refetch();
    }

    useEffect(()=>{
        if(itemHist){
            setHistList(itemHist.map((item,index)=>({
                ...item,
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm'),
                id:index,
                r_item: 
                    (item.r_tno && item.r_tno === null) ? 
                    (item.s_tno !== null) ? (item.s_tno +' | '+ ((item.s_lot_no !== null && item.s_lot_no) !== '' ? item.s_lot_no : '-')) : '-'
                    : 
                    (item.r_tno !== null) ? (item.r_tno +' | '+ ((item.r_lot_no !== null && item.r_lot_no) !== '' ? item.r_lot_no : '-')) : '-' ,
                is_ing: item.is_ing === 0 ? '완료' : '진행중',
                ret_stnnm: item.io_st === 'O' ? ' - ': item.ret_stnnm, 
                reg_dt: moment(item.reg_dt).format('YYYY/MM/DD HH:mm')})
                ));
        }else{
            setHistList([])
        }
    },[itemHist])

    return (
        <MainWrap>
            {/* <div style={{height:'1rem'}} /> */}
            <Row style={{justifyContent:'space-between'}}>
                <div style={{display:'flex',gap:'8px',justifyContent:'space-between',alignItems:'center'}}>
                <TextField 
                    id='sdate'
                    label='등록일자(FROM)' 
                    style={{width:'10rem'}} 
                    InputLabelProps={{shrink:true}} 
                    type='date' 
                    size='small' 
                    onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                />
                ~
                <TextField 
                    id='edate'
                    label='등록일자(TO)' 
                    style={{width:'10rem'}} 
                    InputLabelProps={{shrink:true}} 
                    type='date' 
                    size='small' 
                    onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                />
                </div>
                <Button style={{width:'120px'}} onClick={goSearch}>검색</Button>
            </Row>
            {/* <div style={{height:'1rem'}} /> */}
            <div style={{height:'80vh'}}>
            <CommonDataGrid
                isLoading={isLoading}
                list={histList}
                columns={histColumns}
                // onRowClick={(e)=>{setTarget(e.row);setRegOpen(true)}}
                />
            </div>
        </MainWrap>
    )

}

export default InoutHist;